<form class="f-col blank-form">
    <div class="section-heading">
        <h2 class="h2-heading">{{content?.['b2b.managetraveler.managedevices'] || 'Manage devices'}}</h2>
    </div>

    <div class="section-content cm-manage-device">
        <div class="inner-contentsection">
            <div class="custom-list" *ngIf="items.length; else noDevices">
                <div class="list-item" *ngFor="let item of items">
                    <div class="cm-content">
                        <h5>{{ item?.type | titlecase }}</h5>
                        <p>{{ formatCreatedAt(item?.created_at) }}</p>
                    </div>
                    <div class="device-actions">
                        <!-- <mat-spinner *ngIf="isDeleting(item)" diameter="20"></mat-spinner> -->
                        <button class="delete-btn" type="button" [disabled]="isDeleting(item)" (click)="removeItem(item)">
                            <mat-icon fontSet="material-symbols-outlined">remove</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
            <ng-template #noDevices>
                <div class="empty-state-wrapper f-col-center" *ngIf="!isLoading">
                    <img src="assets/images/empty-state-cam.svg" alt="No data available">
                    <p>{{content?.['b2b.managetraveler.nopasskeysavailable'] || 'No passkeys available'}}</p>
                </div>
            </ng-template>
          
        </div>
    </div>
</form>

<ng-template #revokeWarning>
    <div class="custom-dialog">
        <div class="d-justify-bw">
            <div class="custom-dialog__left">
                <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                    <h2 class="mat-dialog-title">{{content?.['b2b.managetraveler.confirmrevokedevice'] || 'Are you sure to revoke this device?'}}</h2>
                    <div class="custom-overlay-close">
                        <mat-icon fontSet="material-symbols-outlined" class="close_icon" tabindex="0" role="button" (keyup.enter)="closeRevokeDialog()" (keyup.space)="closeRevokeDialog()" (click)="closeRevokeDialog()">close</mat-icon>
                    </div>
                </div>
                <mat-dialog-content class="custom-dialog__text">
                    <div class="custom-dialog__description">{{content?.['b2b.managetraveler.logoutfromdevice'] || 'You will be logged out from this device.'}}</div>
                </mat-dialog-content>
                <mat-dialog-actions>
                    <div class="dialog-actions-right">
                        <button class="button--secondary-small" mat-button type="button" [disabled]="isRevoking" (click)="closeRevokeDialog()">{{ content?.['b2b.managetraveler.cancel'] || 'Cancel' }}</button>
                        <button class="button--primary-small confirmBtn" mat-button type="button" [disabled]="isRevoking" (click)="confirmRevoke()">
                            <mat-spinner class="button" *ngIf="isRevoking" diameter="20"></mat-spinner>
                            {{ paymentContent?.['b2b.payment.termsandcondition.okay'] }}
                        </button>
                    </div>
                </mat-dialog-actions>
            </div>
        </div>
    </div>
</ng-template>
